exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:769px){.dashboard-wrapper[data-v-50c58cf0],.dashboard-wrapper .funeral-list[data-v-50c58cf0],.dashboard-wrapper>*[data-v-50c58cf0]{max-height:calc(100vh - 113px)}.dashboard-wrapper .funeral-list[data-v-50c58cf0]{overflow:auto}}@media screen and (max-width:768px){.dashboard-wrapper[data-v-50c58cf0]{overflow:auto}.dashboard-wrapper .funeral-list[data-v-50c58cf0]{overflow:none}}.funeral-list[data-v-50c58cf0]{padding:1rem}", ""]);

// exports
